import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import RoundedButton from 'Components/ComponentLibrary/Atoms/Inputs/RoundedButton';
import useConfirmationDialogState from 'Hooks/useConfirmationDialogState';
import NewDialog from 'Components/UI/ConfirmationDialog/NewDialog';


const styles = () => ({
  root: {
    width: '60%',
  },
  button: {
    display: 'flex',
    justifyContent: 'center',
  },
});

const EditAggregatorLayout = ({
  className,
  classes,
}) => {
  const { onSubmit } = useMetaLayoutContext();

  const {
    dialogOpen,
    loading,
    handleSubmit,
    handleOpen,
    handleClose,
  } = useConfirmationDialogState({
    onSubmit,
  });

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      {dialogOpen && (
        <NewDialog
          message={'All account linking will use this aggregator'}
          // cancelLabel={cancelLabel}
          confirmLabel={'Update'}
          confirmButtonType="error"
          loading={loading}
          onConfirm={async () => {
            await handleSubmit();
            handleClose();
          }}
          onCancel={() => { handleClose(); }}
          onClose={() => { handleClose(); }}
          showCloseIcon={false}
        />
      )}
      <MetaControlField attr={'activeAggregator'} />
      <MetaControlField attr={'linkingInstructions'} />
      <Box className={classes.button}>
        <RoundedButton
          fullWidth
          size={'md'}
          onClick={handleOpen}
        >
          Update Aggregator
        </RoundedButton>
      </Box>
    </Box>
  );
};

EditAggregatorLayout.defaultProps = {
  className: '',
};

EditAggregatorLayout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(EditAggregatorLayout);
